import { cx } from '@emotion/css';
import { ArrowForwardRounded, EmojiEventsTwoTone } from '@mui/icons-material';
import type { GetAgencyAwardsQuery } from '@sortlist-frontend/data-fetching/public-types';
import { Button, Divider } from '@sortlist-frontend/design-system/legacy';
import { useTranslation } from '@sortlist-frontend/translation/ssr';
import type { DeepNonNullable } from '@sortlist-frontend/utils';
import { Fragment, useState } from 'react';

import { WorkDetailModal } from '_components/common/WorkDetailModal/WorkDetailModal';
import { agencyProfileConfig } from '_features/AgencyProfile/config';

export type AwardNode = DeepNonNullable<GetAgencyAwardsQuery, 4>['agency']['awards']['nodes'][0];

interface Props {
  award: AwardNode;
  scrollCtn?: Element | null;
  disableCache?: boolean;
  className?: string;
}

export const Award = (props: Props) => {
  const { award, className } = props;
  const { work } = award;
  const { t } = useTranslation(agencyProfileConfig.i18nNamespaces);
  const [open, setOpen] = useState(false);

  const openWork = () => {
    setOpen(true);
  };

  const closeDialog = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <div className={cx(className, 'p-2 layout-column')}>
        <div className="rounded-md shadow-2 bg-neutral-50 flex-1 layout-column border border-content-900 layout-align-space-between">
          <div className="layout-column layout-align-start-start p-4">
            <div className="rounded-full bg-secondary-200 layout-column layout-align-center-center text-center p-4 mb-8">
              <EmojiEventsTwoTone className="text-secondary-700" style={{ fontSize: 46 }} />
            </div>
            <span className="bold mb-2">{award.name}</span>
            <span className="small text-secondary-900 mb-4">{award.wonAt}</span>
            <span className="small text-secondary-500 mb-2 text-break-word">{award.category}</span>
          </div>
          {award.work && (
            <div>
              <Divider />
              <Button
                onClick={openWork}
                buttonStyle="secondary"
                buttonVariant="default"
                size="md"
                className="text-left small"
                iconRight={<ArrowForwardRounded style={{ fontSize: 16 }} />}
                label={t('agency:profile.awards.link')}
                id={`open-work-btn-${work?.slug}`}
              />
            </div>
          )}
        </div>
      </div>

      {work && open && (
        <WorkDetailModal
          open={open}
          onClose={closeDialog}
          workSlug={work.slug}
          workSlugs={undefined}
          works={[]}
          index={0}
        />
      )}
    </Fragment>
  );
};
